<template>
  <table class="do-table" :class="{'is-absence-integration-active': isAbsenceIntegrationActive}">
    <thead>
    <tr>
      <th></th>
      <th class="hide-title-th width-40 text-left"
          v-if="isAbsenceIntegrationActive && isSalarySystemKMD"
          :content='"Fraværskoden er den kode, der skal bruges i Opus, når en medarbejder har fravær. Vælges en kode, vil der automatisk blive oprettet en fraværsindberetning i Opus."'
          v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
              }">Fraværskode i OPUS <span class="icon-question3"></span>
      </th>
      <th class="hide-title-th width-40 text-left"
          v-if="isAbsenceIntegrationActive && isSalarySystemSD"
          :content='"Fraværskoden er den kode, der skal bruges i SD, når en medarbejder har fravær. Vælges en kode, vil der automatisk blive oprettet en fraværsindberetning i SD."'
          v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
              }">Fraværskode i SD <span class="icon-question3"></span>
      </th>
      <th class="hide-title-th"
          :content='tooltipForHideTitle'
          v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
              }">{{ i18n['hide_title'] }} <span class="icon-question3"></span>
      </th>
      <th class="hide-title-th"
          :content='tooltipForDefaultOngoing'
          v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
              }">{{ i18n['default_ongoing'] }} <span class="icon-question3"></span>
      </th>
      <th class="hide-title-th"
          v-if="isAbsenceRequestActivated"
          :content='tooltipForCanBeRequested'
          v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
              }">{{ i18n['can_be_requested'] }} <span class="icon-question3"></span>
      </th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="reason in items" :key="reason.id" >
      <td>{{ reason.name }}</td>
      <td v-if="isAbsenceIntegrationActive && isSalarySystemKMD" class="width-40">
        <div v-if="reason.kmd_absence_code_id && editingAbsenceCodeId !== reason.id" class="absence-code-display">
          <span class="absence-code-text">{{ getAbsenceCodeName(reason.kmd_absence_code_id, false) }}</span>
          <!-- REMOVE POSSIBILITY TO CHANGE THE ABSENCE CODE 
          <div class="icon__bg-circle icon__bg-circle--edit" @click.stop="setEditingAbsenceCode(reason.id)">
            <span class="icon-pencil"></span>
          </div>
          -->
        </div>
        <!-- REMOVE POSSIBILITY TO CHANGE THE ABSENCE CODE 
        <select
          v-if="!reason.kmd_absence_code_id || editingAbsenceCodeId === reason.id"
          class="do-select" 
          :data-reason-id="reason.id"
          v-model="reason.kmd_absence_code_id"
          @change="onAbsenceCodeChange(reason, $event.target.value, false)"
          @blur="editingAbsenceCodeId = null">
          <option value="">— Ingen —</option>
          <option v-for="code in absenceCodes" :value="code.id" :key="code.id">{{ code.absence_type + ' - ' + code.absence_type_text }}</option>
        </select>
        -->
      </td>
      <td v-if="isAbsenceIntegrationActive && isSalarySystemSD" class="width-40">
        <div v-if="reason.sd_absence_code_id" class="absence-code-display">
          <span class="absence-code-text">{{ getAbsenceCodeName(reason.sd_absence_code_id, true) }}</span>
          <!-- REMOVE POSSIBILITY TO CHANGE THE ABSENCE CODE
          <div class="icon__bg-circle icon__bg-circle--edit" @click.stop="setEditingAbsenceCode(reason.id)">
            <span class="icon-pencil"></span>
          </div>
          -->
        </div>
        <!-- REMOVE POSSIBILITY TO CHANGE THE ABSENCE CODE
        <select
          v-if="!reason.sd_absence_code_id || editingAbsenceCodeId === reason.id"
          class="do-select"
          :data-reason-id="reason.id"
          v-model="reason.sd_absence_code_id"
          @change="onAbsenceCodeChange(reason, $event.target.value, true)"
          @blur="editingAbsenceCodeId = null">
          <option value="">— Ingen —</option>
          <option v-for="code in sdAbsenceCodes" :value="code.id" :key="code.id">{{ code.loenart ? code.loenart + ' - ' : '' }}{{ code.title }}</option>
        </select>
        -->
      </td>
      <td class="hide-title-td">
        <div class="do-table-flex" @click.stop="onToggleDefaultPrivate(reason)">
          <AppToggle :propOn="reason.default_private" :allowChanges="false"></AppToggle>
        </div>
      </td>
      <td class="hide-title-td">
        <div class="do-table-flex default-ongoing-wrapper" :class="{'default-ongoing-disabled': isDefaultOngoingDisabled(reason)}" @click.stop="onToggleDefaultOngoing(reason)">
          <div class="default-ongoing-overlay" v-if="isDefaultOngoingDisabled(reason)"></div>
          <AppToggle :propOn="reason.default_ongoing" :allowChanges="false"></AppToggle>
        </div>
      </td>
      <td class="hide-title-td" v-if="isAbsenceRequestActivated">
        <div class="do-table-flex" @click.stop="onToggleCanRequest(reason)">
          <AppToggle :propOn="reason.can_request" :allowChanges="false"></AppToggle>
        </div>
      </td>
      <td>
        <button class="do-bttn do-bttn--small" :class="{'do-bttn--loading': theUpdatingReasonId === reason.id}"
                @click="$emit('toggleArchived', reason)">{{
            reason.archived ? i18n['dearchive'] : i18n['archive']
          }}
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
import AppToggle from '../common/AppToggle.vue'

const I18N = {
  da: {
    absence_reasons: 'Fraværsårsager',
    create_absence: 'Opret fraværsårsag',
    need_a_title: 'Mangler et navn',
    title: 'Navn',
    hide_title: 'Skjul titel',
    archive: 'Arkivér',
    dearchive: 'Genskab',
    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
    tooltip_for_hide_title: 'Når "Skjul titel" er aktiveret, er fraværstitlen kun synlig for administratorer og brugeren med fraværet – for andre vises blot "Fravær". Hvis indstillingen deaktiveres, er titlen synlig for alle, også i Aula.',
    can_be_requested: 'Kan anmodes',
    tooltip_for_can_be_requested: 'Medarbejdere kan vælge denne årsag, når de anmoder om fravær',
    default_ongoing: 'Løbende fravær',
    tooltip_for_default_ongoing: 'Aktivér for automatisk at markere fraværet som løbende, når denne årsag vælges ved oprettelse af fravær'
  },
  nb: {
    absence_reasons: 'Fraværsårsaker',
    create_absence: 'Opprett fraværsårsak',
    hide_title: 'Skjul tittel',
    archive: 'Arkiver',
    dearchive: 'Gjenopprett',
    title: 'Navn',
    need_a_title: 'Mangler et navn',
    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
    tooltip_for_hide_title: 'Når "Skjul tittel" er aktivert, er fraværstittelen kun synlig for administratorer og brukeren fraværet gjelder – for andre vises bare "Fravær". Hvis innstillingen deaktiveres, blir tittelen synlig for alle.',
    can_be_requested: 'Kan forespørres',
    tooltip_for_can_be_requested: 'Ansatte kan velge denne årsaken når de ber om fravær',
    default_ongoing: 'Løpende fravær',
    tooltip_for_default_ongoing: 'Aktiver for automatisk å merke fraværet som løpende når denne årsaken velges ved registrering av fravær'
  },
  en: {
    absence_reasons: 'Absence reasons',
    create_absence: 'Create absence reason',
    hide_title: 'Hide title',
    archive: 'Archive',
    dearchive: 'Restore',
    title: 'Name',
    need_a_title: 'Missing a name',
    no_absence_reasons_created: 'No absence reasons created',
    tooltip_for_hide_title: 'When "Hide title" is enabled, the absence title is only visible to administrators and the user the absence relates to – others will simply see "Absence". If the setting is disabled, the title becomes visible to everyone.',
    can_be_requested: 'Can be requested',
    tooltip_for_can_be_requested: 'Employees can select this reason when requesting absence',
    default_ongoing: 'Ongoing absence',
    tooltip_for_default_ongoing: 'Enable to automatically mark the absence as ongoing when this reason is selected when creating an absence'
  }
}
export default {
  components: {AppToggle},
  data () {
    return {
      editingAbsenceCodeId: null
    }
  },
  props: {
    items: {
      default: []
    },
    theUpdatingReasonId: {
      default: null
    },
    isAbsenceRequestActivated: {
      default: false
    },
    isAbsenceIntegrationActive: {
      type: Boolean,
      default: false
    },
    absenceCodes: {
      type: Array,
      default: () => []
    },
    sdAbsenceCodes: {
      type: Array,
      default: () => []
    },
    salarySystem: {
      type: String,
      default: 'SD'
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    tooltipForHideTitle () {
      return this.i18n['tooltip_for_hide_title']
    },
    tooltipForCanBeRequested () {
      return this.i18n['tooltip_for_can_be_requested']
    },
    tooltipForDefaultOngoing () {
      return this.i18n['tooltip_for_default_ongoing']
    },
    isSalarySystemSD () {
      return this.salarySystem === 'SD'
    },
    isSalarySystemKMD () {
      return this.salarySystem !== 'SD'
    }
  },
  methods: {
    getAbsenceCodeName (codeId, isSD) {
      if (!codeId) {
        return ''
      }
      if (isSD) {
        if (!this.sdAbsenceCodes || !Array.isArray(this.sdAbsenceCodes)) {
          return ''
        }
        const code = this.sdAbsenceCodes.find(c => String(c.id) === String(codeId))
        if (!code) {
          return ''
        }
        return (code.loenart ? code.loenart + ' - ' : '') + (code.title || '')
      } else {
        if (!this.absenceCodes || !Array.isArray(this.absenceCodes)) {
          return ''
        }
        const code = this.absenceCodes.find(c => String(c.id) === String(codeId))
        if (!code) {
          return ''
        }
        return code.absence_type + (code.absence_type_text ? ' - ' + code.absence_type_text : '')
      }
    },
    setEditingAbsenceCode (reasonId) {
      this.editingAbsenceCodeId = reasonId
      this.$nextTick(() => {
        const selectElement = this.$el.querySelector(`select[data-reason-id="${reasonId}"]`)
        if (selectElement) {
          selectElement.focus()
        }
      })
    },
    onAbsenceCodeChange (reason, value, isSD) {
      if (isSD) {
        // SD codes har ikke allow_open property, så vi sender bare værdien
        this.$emit('editAbsenceCode', reason, value, null, true)
      } else {
        // Tjek om den valgte kode muliggør eller ikke muliggør default_ongoing
        const selectedCode = value ? this.absenceCodes.find(c => c.id === parseInt(value, 10)) : null
        const shouldDisableDefaultOngoing = selectedCode && this.isAbsenceIntegrationActive && selectedCode.allow_open === false
        const shouldEnableDefaultOngoing = selectedCode && this.isAbsenceIntegrationActive && selectedCode.allow_open === true

        // Hvis koden ikke muliggør default_ongoing, nulstil den
        if (shouldDisableDefaultOngoing && reason.default_ongoing) {
          this.$emit('editAbsenceCode', reason, value, false, false)
        } else if (shouldEnableDefaultOngoing && !reason.default_ongoing) {
          // Hvis koden muliggør default_ongoing, slå den til
          this.$emit('editAbsenceCode', reason, value, true, false)
        } else {
          this.$emit('editAbsenceCode', reason, value, null, false)
        }
      }
      this.editingAbsenceCodeId = null
    },
    isDefaultOngoingDisabled (reason) {
      if (!this.isAbsenceIntegrationActive) {
        return false
      }
      if (this.isSalarySystemSD) {
        // SD codes har ikke allow_open property, så default_ongoing er ikke disabled
        return false
      }
      if (!reason.kmd_absence_code_id) {
        return false
      }
      const code = this.absenceCodes.find(c => c.id === reason.kmd_absence_code_id)
      return code && code.allow_open === false
    },
    onToggleDefaultPrivate (reason) {
      this.$emit('editAbsencePrivate', reason)
    },
    onToggleDefaultOngoing (reason) {
      if (!this.isDefaultOngoingDisabled(reason)) {
        this.$emit('editAbsenceOngoing', reason)
      }
    },
    onToggleCanRequest (reason) {
      this.$emit('editAbsenceCanRequest', reason)
    }
  }
}
</script>

<style scoped>
.do-table {
  width: 100%;
  table-layout: auto; /* vigtig: så indhold kan bestemme minimum */
}

.do-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}

.do-table thead th {
  background: #f6f9fc;
  border-bottom: 1px solid #e3e8ee;
  position: sticky;
  top: 0;
  z-index: 10;
}

.do-table tr {
  border-bottom: 1px solid #e3e8ee;
}

.do-table tr:hover {
  background-color: aliceblue;
}

.do-table tr td:first-child {
  font-weight: bold;
}

.do-table tr th:first-child,
.do-table tr td:first-child {
  width: 300px;
}
.do-table tr td {
  border-left: 1px solid #e2e8f0;
}
.do-table tr td:last-child {
  text-align: right;
}

.do-table-flex {
  display: flex;
  align-items: center;
}

.hide-title-th {
  cursor: help;
}

.do-bttn.do-bttn--small {
  font-size: 11px;
  height: auto;
  padding: 5px 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

table th:nth-child(1),
table td:nth-child(1) { width: 40%; }

table th.width-40,
table td.width-40 { width: 40%; }

/* resten */
.do-table th:nth-child(n+3),
.do-table td:nth-child(n+3) {
  white-space: nowrap;
}

/* valgfrit: sørg for at toggle-kolonner ikke bliver for smalle */
.do-table td:nth-child(3),
.do-table td:nth-child(4),
.do-table td:nth-child(5),
.do-table th:nth-child(3),
.do-table th:nth-child(4),
.do-table th:nth-child(5) {
  min-width: 110px; /* justér efter din toggle størrelse */
}

/* sidste kolonne (knap) */
.do-table th:last-child,
.do-table td:last-child {
  min-width: 120px; /* så knappen ikke mases */
}

.text-left {
  text-align: left;
}

.absence-code-display {
  display: flex;
  align-items: center;
  gap: 8px;
}

.absence-code-text {
  flex: 1;
}

.absence-code-edit {
  cursor: pointer;
  color: #468AD7;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.absence-code-edit:hover {
  opacity: 1;
}

.icon__bg-circle--edit {
  opacity: 0;
}

tr:hover .icon__bg-circle--edit {
  opacity: 1;
}

.do-table-flex {
  cursor: pointer;
}

.default-ongoing-wrapper {
  position: relative;
}

.default-ongoing-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  opacity: 0.7;
  z-index: 2;
  pointer-events: all;
  cursor: not-allowed;
  border-radius: 4px;
}

.default-ongoing-disabled {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// AbsenceReasonsTable.vue?40b6e386